import type { DeliveryData } from "../../types/DeliveryData";

type AddressData = {
  buildingInfo: string;
  city: string;
  prefecture: string;
  recipientName: string;
  streetNum: string;
  zipCode: string;
};

/** SPWN側の配送先住所を画面のお届け先表示へ */
export const toDeliveryData = (addressData: AddressData): DeliveryData => ({
  recipientName: addressData.recipientName,
  postalCode: addressData.zipCode,
  mainAddress: `${addressData.prefecture}${addressData.city}${addressData.streetNum}`,
  subAddress: addressData.buildingInfo,
});
